export type AdminAuthIdentifiers = {
  userPoolId: string;
  userPoolClientId: string;
  identityPoolId: string;
};

const PREVIEW_AUTH_IDENTIFIERS: AdminAuthIdentifiers = {
  userPoolId: 'us-east-1_6P8JMokd5',
  userPoolClientId: '3eqjigk68ue67asc8q09spc7j1',
  identityPoolId: 'us-east-1:77c14b3c-c210-44bb-9e05-ce4b678a09cb',
};

const PREVIEW_ADMIN_EMAIL = 'owner@preview.example.com';

export const isPreviewAdminHostname = (hostname: string): boolean =>
  /^pr-\d+-admin\.preview\.chiroup\.com$/.test(hostname);

export const resolveAdminAuthIdentifiers = (
  hostname: string,
  defaults: AdminAuthIdentifiers
): AdminAuthIdentifiers => (isPreviewAdminHostname(hostname) ? PREVIEW_AUTH_IDENTIFIERS : defaults);

export const resolvePreviewAdminEmail = (hostname: string): string =>
  isPreviewAdminHostname(hostname) ? PREVIEW_ADMIN_EMAIL : '';
